import { useState, useEffect } from 'react';
import api from '@/services/api';

interface AwsSettings {
  aws_access_key: string;
  aws_secret_key: string;
  aws_region: string;
  aws_account_id: string;
  input_bucket: string;
  output_bucket: string;
  key_name: string;
  security_group_id: string;
  subnet_id: string;
  efs_databases?: string;
  efs_params?: string;
  ecr_repo?: string;
}

export const useAwsSettings = () => {
  const [settings, setSettings] = useState<AwsSettings | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [isComplete, setIsComplete] = useState(false);

  useEffect(() => {
    const fetchSettings = async () => {
      setLoading(true);
      setError(null);
      
      try {
        const response = await api.get('/api/user/aws-settings/');
        
        if (response.data && response.data.length > 0) {
          const awsSettings = Array.isArray(response.data) ? response.data[0] : response.data;
          setSettings(awsSettings);
          
          // Check if all required fields are filled
          const requiredFields: (keyof AwsSettings)[] = [
            'aws_access_key',
            'aws_secret_key',
            'aws_region',
            'aws_account_id',
            'input_bucket',
            'output_bucket',
            'key_name',
            'security_group_id',
            'subnet_id'
          ];
          
          const hasAllRequiredFields = requiredFields.every(field => 
            awsSettings[field] && awsSettings[field].trim() !== ''
          );
          
          setIsComplete(hasAllRequiredFields);
        } else {
          setSettings(null);
          setIsComplete(false);
        }
      } catch (error) {
        console.error('Error fetching AWS settings:', error);
        setError('Failed to fetch AWS settings');
        setIsComplete(false);
      } finally {
        setLoading(false);
      }
    };

    fetchSettings();
  }, []);

  return { settings, loading, error, isComplete };
}; 